<template>
  <TemplateRegistro :titulo="titulo" @intro="submit()">
    <label class="texto">
      MMT Seguros quiere tenerte informado de novedades, promociones y ofertas
      que comercialice. ¿Quieres conocerlas?
    </label>
    <button class="pure-button boton" @click="actualizaGdpr()">
      Si, Acepto
    </button>
    <button class="pure-button gris" @click="especificar()">
      Especificar opciones
    </button>
    <br />
    <a
      class="linkgris"
      href="https://www.mmtseguros.com/hubfs/Documentacion_Area_Cliente/politica_de_privacidad_area_cliente.pdf"
      target="_blank"
      >Política de Privacidad</a
    >
  </TemplateRegistro>
</template>

<script>
export default {
  data() {
    return {
      cliente: this.$store.state.portfolio.cliente,
      titulo: "Comunicaciones",
    };
  },

  methods: {
    actualizaGdpr: async function () {
      await this.$store.dispatch("actualizaGdpr", {
        gdprEmpresas: true,
      });
      this.$store.dispatch("getPortfolio");
      this.$store.dispatch("getUrlClubMMT");
      this.$router.replace({ name: "inicio" });
    },

    especificar() {
      this.$router.push({ name: "gdpr" });
    },
  },
};
</script>
<style lang="scss" scoped>
.gdpr {
  min-width: 18rem;
}
.texto {
  font-size: 90%;
  margin-bottom: 1rem;
  color: $azulOscuroMMT;
}
.textoGdpr {
  font-size: 90%;
}
.gris {
  background-color: #fff;
  color: #828282;
  border-color: #d7d7d7;
  border-width: 1 rem;
  border-style: solid;
}
.linkgris {
  color: #828282;
  text-align: center;
  font-size: 70%;
}
</style>
